.Details > summary {
  list-style: none;
}

.Details > summary::-webkit-details-marker {
  display: none;
}
